<script setup lang="ts">
import type { Component } from 'vue'
import { buttonVariants } from '.'
import { cn } from '@/lib/utils'

interface Props {
  variant?: NonNullable<Parameters<typeof buttonVariants>[0]>['variant']
  size?: NonNullable<Parameters<typeof buttonVariants>[0]>['size']
  as?: string | Component
}

withDefaults(defineProps<Props>(), {
  as: 'button',
})
</script>

<template>
  <!-- @ts-ignore -->
  <component
    :is="as"
    :class="cn(buttonVariants({ variant, size }), $attrs.class ?? '')"
  >
    <slot />
  </component>
</template>
